import { render, staticRenderFns } from "./PopoverItem.vue?vue&type=template&id=5790a414&scoped=true&"
import script from "./PopoverItem.vue?vue&type=script&lang=js&"
export * from "./PopoverItem.vue?vue&type=script&lang=js&"
import style0 from "./PopoverItem.vue?vue&type=style&index=0&id=5790a414&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5790a414",
  null
  
)

export default component.exports